<div 
  class="relative w-[400px] h-[440px] rounded-2xl overflow-hidden cursor-pointer p-3 
  bg-gradient-to-br to-transparent from-lGray400/60 border border-lGray600
  transition-all duration-500 ease-in-out backdrop-blur-sm hover:w-[480px]"
>
  <div class="group">
    <a
      [routerLink]="courseDetailsRoute"
      class="relative block h-[410px] w-full rounded-2xl overflow-hidden group-hover:hidden"
      [attr.aria-label]="'Abrir detalhes do curso ' + (course.title || '')"
    >
      <img [src]="course.coverImageUrl || 'assets/images/course-default.png'" [alt]="course.title || 'Curso'"
        class="w-full h-full object-cover transition-all duration-500" />

      <div class="absolute inset-0 bg-gradient-to-t from-black to-transparent"></div>

      <span class="absolute bottom-4 left-4 text-white text-xl font-semibold">
        {{ course.title }}
      </span>
    </a>

    <div 
      class="absolute inset-3 flex flex-col bg-transparent w-[455px] opacity-0 
      transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:scale-100"
    >
      <a
        [routerLink]="courseDetailsRoute"
        class="relative block h-[250px] w-[455px] rounded-2xl overflow-hidden"
        [attr.aria-label]="'Abrir detalhes do curso ' + (course.title || '')"
      >
        <img [src]="course.coverImageUrl || 'assets/images/course-default.png'" [alt]="course.title" class="w-full h-full bg-no-repeat" />

        <div class="absolute inset-0 bg-gradient-to-t from-black to-transparent"></div>

        <h3 class="absolute bottom-4 left-4 text-white text-lg font-semibold">
          {{ course.title }}
        </h3>
      </a>

      <div class="flex-1 p-5 flex flex-col justify-between">
        <div class="space-y-4">
          <div class="flex items-center justify-between gap-2">
            <div class="flex items-center">
              <div class="w-10 h-9 pl-1 flex items-center justify-center rounded-l-full bg-lBlack text-lWhite">
                <l-icon class="text-lg">{{ courseLocationIcon }}</l-icon>
              </div>

              <span class="px-3 py-2 rounded-r-full text-sm bg-lGray600 text-lWhite">
                {{ courseLocationLabel }}
              </span>
            </div>

            <div class="flex gap-2">
              <span class="px-4 py-2 rounded-full text-sm bg-lGray600 text-lWhite">
                {{ modulesCountLabel }}
              </span>

              <span class="px-4 py-2 rounded-full text-sm bg-lGray600 text-lWhite">
                {{ durationLabel }}
              </span>
            </div>

          </div>

          @if (showDescription) {
            <p class="text-sm text-lWhite leading-relaxed">
              {{ course.description }}
            </p>
          }

          @if (showProgress) {
            <div class="flex items-center !mt-6 gap-2">
              <div class="h-3 w-full rounded-full overflow-hidden bg-lGray600">
                <div
                  class="h-full rounded-full transition-all duration-500 bg-gradient-progress"
                  [style.width]="progressBarWidth"
                ></div>
              </div>
              <span class="text-lWhite text-sm font-normal leading-none">{{ progress }}%</span>
            </div>
          }

        </div>

        @if (showProgress) {
          <div class="mt-6 grid grid-cols-2 gap-3">
            <button lButton [routerLink]="['/courses', course.id]" [bRadius]="buttonRadiusEnum.LARGE" [bType]="buttonTypeEnum.BASIC">Ver mais</button>
            <button lButton [routerLink]="secondaryCtaRoute" [bRadius]="buttonRadiusEnum.LARGE" [bType]="buttonTypeEnum.PRIMARY">{{ secondaryCtaLabel }}</button>
          </div>
        } @else {
          <button lButton [routerLink]="['/courses', course.id]" [bRadius]="buttonRadiusEnum.LARGE" [bType]="buttonTypeEnum.BASIC" class="mt-4">Ver mais</button>
        }
      </div>
    </div>
  </div>
</div>